import { useXvvsApr } from 'hooks/useXvvsApr'

export default function usePastWeekApr() {
  return useXvvsApr({
    timeOffset: {
      days: -7,
    },
  }).avgApr
}
